import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { alertSubscriptionStoreSelector } from '../alertSubscription.selector';

export const isAlertCellProcessingSelector = createCachedSelector(
  [
    path(alertSubscriptionStoreSelector).processingCells(),
    prop<{ cellKey: string }>().cellKey(),
  ],
  (processingCells, cellKey) => processingCells.has(cellKey),
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ cellKey: string }>().cellKey(),
});
